import React from "react"
import styled from "styled-components"

import { Section, Container } from "../global"

const Themes = () => (
  <Section id="themes">
    <StyledContainer>
      <Subtitle>Strategy</Subtitle>
      <SectionTitle>Investment Themes</SectionTitle>
      <FeaturesGrid>
        <FeatureItem>
          <FeatureTitle>AR & VR</FeatureTitle>
          <FeatureText>
            Startups like Modsy are transforming how real estate planning and transactions occur. 
          </FeatureText>
        </FeatureItem>
        <FeatureItem>
          <FeatureTitle>Crowdfunding</FeatureTitle>
          <FeatureText>
            Startups like RealT are using the blockchain to disrupt property ownership.
          </FeatureText>
        </FeatureItem>
        <FeatureItem>
          <FeatureTitle>Automation</FeatureTitle>
          <FeatureText>
            Startups like Better.com are automating traditional business processes, drastically lowering costs.
          </FeatureText>
        </FeatureItem>
        <FeatureItem>
          <FeatureTitle>FinTech</FeatureTitle>
          <FeatureText>
            Startups like Doorstead are changing financing and risk management in the real estate process. 
          </FeatureText>
        </FeatureItem>
      </FeaturesGrid>
    </StyledContainer>
  </Section>
)

export default Themes

const StyledContainer = styled(Container)``

const SectionTitle = styled.h3`
  color: ${props => props.theme.color.primary};
  display: flex;
  justify-content: center;
  margin: 0 auto 40px;
  text-align: center;
`

const Subtitle = styled.h5`
  font-size: 16px;
  color: ${props => props.theme.color.accent};
  letter-spacing: 0px;
  margin-bottom: 12px;
  text-align: center;
`

const FeaturesGrid = styled.div`
  max-width: 670px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  margin: 0px auto;
  grid-column-gap: 40px;
  grid-row-gap: 35px;
  @media (max-width: ${props => props.theme.screen.sm}) {
    grid-template-columns: 1fr;
    padding: 0 64px;
  }
`

const FeatureItem = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`

const FeatureTitle = styled.h4`
  color: ${props => props.theme.color.primary};
  letter-spacing: 0px;
  line-height: 30px;
  margin-bottom: 10px;
`

const FeatureText = styled.p`
  text-align: center;
`
